import React, { useMemo } from "react";

import { useUsers } from "~/shared";
import { useAuthStore, usePatientStore } from "~/stores";
import {
  buildCoachVisitSchema,
  CoachVisitFormData,
  CoachVisitSelfPayFormData,
  RegisteredCoachVisitFormData,
  RegisteredCoachVisitSelfPayFormData,
} from "../validation/schema";
import { VisitForm } from "./VisitForm";

type CoachVisitFormProps = {
  onSubmit: (
    data:
      | CoachVisitFormData
      | RegisteredCoachVisitFormData
      | CoachVisitSelfPayFormData
      | RegisteredCoachVisitSelfPayFormData,
  ) => void;
  isLoading?: boolean;
};

export const CoachVisitForm = ({
  onSubmit,
  isLoading = false,
}: CoachVisitFormProps) => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());
  const { getCurrentUser } = useUsers();
  const { data: currentUser } = getCurrentUser(isLoggedIn);
  const hasEhrId = !!currentUser?.ehrId;
  const insuranceData = usePatientStore((state) => state.insuranceData);
  const hasInsurance = !!insuranceData?.covers_coaching;

  const schema = useMemo(
    () => buildCoachVisitSchema(hasEhrId, hasInsurance),
    [hasEhrId, hasInsurance],
  );

  return (
    <VisitForm schema={schema} onSubmit={onSubmit} isLoading={isLoading}>
      {!hasEhrId && <VisitForm.GeneralInfo />}
      {!hasEhrId && <VisitForm.ContactInfo />}
      <VisitForm.Address />
      {hasInsurance && <VisitForm.Insurance />}
      <VisitForm.Consents />
      <VisitForm.CancellationPolicy />
      <VisitForm.SubmitSection />
    </VisitForm>
  );
};
